import formatPhoneNumber from '../../helpers/formatPhoneNumber';

/**
 * Prevent duplicate phone links
 * @param {object} opts
 * @param opts.people
 * @param [opts.phone]
 * @returns {*}
 */
const unlinkPhones = (opts = {}) => {
  const uniquePhones = [];

  if (!opts.people || !opts.people.length) {
    return null;
  }
  const { people, phone } = opts;
  // Add phone if available (Used primarily for phone seo page)
  if (phone) {
    uniquePhones.push(
      formatPhoneNumber({
        phoneNumber: phone
      })
    );
  }

  const newPeople = people;
  newPeople.forEach(person => {
    if (Array.isArray(person.phones) && person.phones.length) {
      person.phones.forEach(phoneItem => {
        const match = uniquePhones.filter(
          value =>
            value ===
            formatPhoneNumber({
              phoneNumber: phoneItem.full
            })
        );

        if (match.length > 0) {
          phoneItem['unlink'] = true;
          return phoneItem;
        }

        uniquePhones.push(
          formatPhoneNumber({
            phoneNumber: phoneItem.full
          })
        );
      });
    }
  });

  return newPeople;
};

export default unlinkPhones;
